import { Component } from "react";
import { createPortal } from "react-dom";

export default class PortalReplace extends Component {
    componentDidMount = () => {
        const ssrContent = this.props.domNode.querySelector('[data-ssr-content]');
        if (ssrContent) {
            ssrContent.remove();
        }
    }

    render() {
        return createPortal(this.props.children, this.props.domNode);
    }
}
